import {
  cityDetailView,
  CityDetailViewProperties,
  collectionDetailView,
  CollectionDetailViewProperties,
  eventDetailView,
  genericClick,
  homepageView,
} from 'services/avo';
import { useTrackEvent, useTrackEventOnce } from 'services/datalayer/hooks';
import { StripAutomaticKeys } from 'services/datalayer/types';
import { mapPageEventToDatalayer } from 'services/datalayer/utils';
import { PageEventFragment } from 'types/api/dato-operations.types';

export * from './useOriginClick';

export const useHomePageView = () =>
  useTrackEventOnce({
    trackFn: homepageView,
    variables: {},
    withOrigin: false,
  });

export const useCollectionDetailView = (
  variables: StripAutomaticKeys<CollectionDetailViewProperties>,
) =>
  useTrackEventOnce({
    trackFn: collectionDetailView,
    variables,
    withOrigin: true,
  });

export const useCityDetailView = (
  variables: StripAutomaticKeys<CityDetailViewProperties>,
) =>
  useTrackEventOnce({ trackFn: cityDetailView, variables, withOrigin: true });

export const useEventDetailView = (event: PageEventFragment) =>
  useTrackEventOnce({
    trackFn: eventDetailView,
    variables: mapPageEventToDatalayer(event),
    withOrigin: true,
  });

export const useGenericClick = () =>
  useTrackEvent({
    trackFn: genericClick,
    variables: {},
  });
